import { action, observable } from 'mobx';

import { BooleanStore } from 'ui/base/input';
import { BusyStore } from 'ui/base/button';

import { IPangolinDomain, Schedule } from 'services/pangolin/types';
import { ScheduleDeleteResult, SchedulesService, ScheduleUpdateResult } from 'services/pangolin/schedule_service';

export class ViewScheduleStore {
  private readonly schedule: Schedule;
  enabled: BooleanStore;

  @observable.ref
  busy: BusyStore;

  constructor(schedule: Schedule) {
    this.schedule = schedule;
    this.enabled = new BooleanStore(schedule.enabled);
    this.busy = new BusyStore();
  }

  @action.bound
  handleToggle(domain: IPangolinDomain): Promise<ScheduleUpdateResult> {
    return SchedulesService.update(domain, {
      uuid: this.schedule.uuid,
      enabled: this.enabled.value,
    });
  }

  @action.bound
  async handleDelete(domain: IPangolinDomain): Promise<ScheduleDeleteResult> {
    return await SchedulesService.delete(domain, this.schedule);
  }
}
